import { defineStore } from 'pinia'

import { useOAuthStore } from 'src/stores/oauth.js'

import { fetchFollowedTags, followTag, unfollowTag } from 'src/api/tags.js'

const byName = (a, b) => a.name.localeCompare(b.name)
const same = (a, b) => a.toLowerCase() === b.toLowerCase()

// The hashtags the user follows: their posts come into the home timeline.
export const useFollowedTagsStore = defineStore('followedTags', {
  state: () => ({
    tags: [],
    loaded: false,
  }),
  getters: {
    isFollowed: (state) => (name) => state.tags.some((t) => same(t.name, name)),
  },
  actions: {
    async load() {
      const { data } = await fetchFollowedTags({
        credentials: useOAuthStore().token,
      })
      this.tags = [...data].sort(byName)
      this.loaded = true
    },
    async follow(name) {
      const { data } = await followTag({
        credentials: useOAuthStore().token,
        name,
      })
      if (!this.isFollowed(data.name)) {
        this.tags = [...this.tags, data].sort(byName)
      }
    },
    async unfollow(name) {
      await unfollowTag({ credentials: useOAuthStore().token, name })
      this.tags = this.tags.filter((t) => !same(t.name, name))
    },
  },
})
